import QRCode from "react-qr-code";
import "./App.css";
import { useRef, useState } from "react";

function App() {
  const [url, setUrl] = useState("");
  const qrRef = useRef();

  const downloadQRCode = () => {
    const svg = qrRef.current;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    // Set desired high resolution size
    const imageSize = 1080;
    canvas.width = imageSize;
    canvas.height = imageSize;

    img.onload = () => {
      ctx.drawImage(img, 0, 0, imageSize, imageSize);
      const pngFile = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngFile;
      downloadLink.download = "qr-code-1080x1080.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    img.src = "data:image/svg+xml;base64," + btoa(svgData);
  };

  return (
    <>
      <div className="container-fluid min-vh-100 d-flex flex-column gap-4 justify-content-center align-items-center bg-light px-3">
        <div
          className="qr-box p-4 bg-white shadow rounded w-100"
          style={{ maxWidth: "500px" }}>
          <h2 className="text-center mb-3 fw-bold">QR Code Generator</h2>
          <p className="text-center text-muted mb-4">
            Paste a valid URL to generate and download your QR code.
          </p>

          <div className="mb-3">
            <label htmlFor="urlInput" className="form-label fw-semibold">
              Enter URL
            </label>
            <input
              type="text"
              id="urlInput"
              className="form-control custom-input"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com"
            />
            <div className="form-text">
              Include <code>http://</code> or <code>https://</code> to make it
              valid.
            </div>
          </div>

          <div className="text-center mb-4">
            <div className="bg-white d-inline-block p-2 shadow-sm rounded">
              <QRCode ref={qrRef} value={url} size={200} />
            </div>
          </div>

          <div className="d-grid">
            <button onClick={downloadQRCode} className="btn btn-primary">
              Download QR Code
            </button>
          </div>
        </div>
        <footer className="text-center py-3 small border-top w-100 fixed-bottom">
          Design and Developed by <span className="text-dark">Vishnu🤍.</span>
        </footer>
      </div>
    </>
  );
}

export default App;
